import {
    DEALERGETLISTDSRTRANSACTION_SUCCESS,
    DEALERGETLISTDSRTRANSACTION_FAILED,
    RESET_DEALERGETLISTDSRTRANSACTION,
    LOADING_DEALERGETLISTDSRTRANSACTION,
    NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETLISTDSRTRANSACTION:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETLISTDSRTRANSACTION_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETLISTDSRTRANSACTION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETLISTDSRTRANSACTION:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETLISTDSRTRANSACTION:
            return (state = initialState);
        default:
            return state;
    }
};